<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-09-30 15:49:20
 * @LastEditors: xgx
 * @LastEditTime: 2022-09-30 15:49:20
-->
<template>
   <div>12345信箱</div>
</template>

<script>
export default {

}
</script>

<style>

</style>